import React, { useState } from "react";
import {
  FaSearch,
  FaMicrophone,
  FaMapMarkerAlt,
  FaChevronDown,
} from "react-icons/fa";
import { MdMyLocation } from "react-icons/md";

const SearchCard = () => {
  const [activeTab, setActiveTab] = useState("Buy");
  const [selectedLocation, setSelectedLocation] = useState("Select Location");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const locations = [
    { name: "Patia" },
    { name: "Khandagiri" },
    { name: "Jaydev Vihar" },
    { name: "Chandrasekharpur" },
    { name: "Saheed Nagar" },
  ];

  const tabs = ["Buy", "Featured Projects", "Land", "New Launch", "Commercial"];

  return (
    <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl">
      {/* Tabs */}
      <div className="flex flex-wrap items-center gap-2 sm:gap-4 px-4 sm:px-6 py-4 border-b border-gray-200">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-3 sm:px-4 py-2 text-sm sm:text-base font-medium rounded-lg transition-all whitespace-nowrap ${
              activeTab === tab
                ? "text-blue-900 bg-blue-50"
                : "text-gray-600 hover:text-blue-900 hover:bg-gray-50"
            }`}
          >
            {tab}
          </button>
        ))}
        <button className="ml-auto px-3 sm:px-4 py-2 bg-green-500 text-white text-xs sm:text-sm font-medium rounded-lg hover:bg-green-600 transition-colors whitespace-nowrap">
          Post Property
          <span className="ml-1 text-xs bg-white text-green-600 px-1.5 py-0.5 rounded">
            Free
          </span>
        </button>
      </div>

      {/* Search Bar */}
      <div className="p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 relative">
          {/* Location Dropdown */}
          <div className="relative flex-shrink-0 sm:w-64">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 rounded-lg border border-gray-200 hover:border-blue-500 transition-colors text-left"
            >
              <div className="flex items-center gap-2">
                <FaMapMarkerAlt className="text-blue-600" />
                <span className="text-gray-700 text-sm sm:text-base truncate">
                  {selectedLocation}
                </span>
              </div>
              <FaChevronDown
                className={`text-gray-400 flex-shrink-0 transform transition-transform duration-200 ${
                  isDropdownOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {/* Dropdown List with Fixed Height and Scroll */}
            {isDropdownOpen && (
              <div className="absolute top-full left-0 w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-20 max-h-60 overflow-y-auto">
                {locations.map((loc, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      setSelectedLocation(loc.name);
                      setIsDropdownOpen(false);
                    }}
                    className="w-full text-left px-4 py-3 hover:bg-blue-50 text-gray-700 text-sm sm:text-base border-b border-gray-100 last:border-b-0 transition-colors"
                  >
                    {loc.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Search Input */}
          <div className="flex-1 flex gap-2 sm:gap-3">
            <input
              type="text"
              placeholder="Search"
              className="flex-1 px-4 py-3 bg-gray-50 rounded-lg border border-gray-200 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-sm sm:text-base"
            />
            <button className="px-4 lg:px-8 py-3 bg-blue-900 text-white rounded-lg hover:bg-blue-800 transition-colors font-medium flex items-center gap-2 whitespace-nowrap">
              <FaSearch className="text-sm sm:text-base" />
              <span className="hidden sm:inline">Search</span>
            </button>
          </div>

          {/* Action Buttons */}
          <div className="hidden lg:flex gap-2 sm:gap-3 justify-center sm:justify-start">
            <button className="w-12 h-12 bg-gray-50 rounded-lg border border-gray-200 hover:border-blue-500 hover:bg-blue-50 transition-colors flex items-center justify-center flex-shrink-0">
              <MdMyLocation className="text-blue-600 text-xl" />
            </button>
            <button className="w-12 h-12 bg-gray-50 rounded-lg border border-gray-200 hover:border-blue-500 hover:bg-blue-50 transition-colors flex items-center justify-center flex-shrink-0">
              <FaMicrophone className="text-blue-600 text-xl" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchCard;
